const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    'margin-bottom': theme.spacing.unit,
  },
  formControl: { margin: theme.spacing.unit * 3 },
  textFieldRoot: {
    padding: 0,
    'label + &': { marginTop: theme.spacing.unit * 2.5 },
  },
  textFieldInput: {
    borderRadius: 2,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.background.paper}`,
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create([ 'border-color', 'box-shadow' ]),
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    '&:focus': {
      border: '1px solid #2974ff',
      'box-shadow': 'none',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  textFieldFormLabel: { fontSize: 18 },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/textField/TextFieldStyles.js